import PropTypes from 'prop-types';
import styled from 'styled-components';
import ReactModal from 'react-modal';
import React from 'react';
import { mq, px2rem } from '@stylesheets/tools';

const ReactModalAdapter = ({ className, modalClassName, children, ...props }) => (
  <ReactModal className={modalClassName} portalClassName={className} {...props}>
    {children}
  </ReactModal>
);

ReactModalAdapter.propTypes = {
  className: PropTypes.string.isRequired,
  modalClassName: PropTypes.oneOfType([PropTypes.string, PropTypes.shape()]).isRequired,
  children: PropTypes.node.isRequired
};

const StyledHeaderModal = styled(ReactModalAdapter).attrs({
  overlayClassName: {
    base: 'headerModal__overlay',
    afterOpen: 'headerModal__overlay--after-open',
    beforeClose: 'headerModal__overlay--before-close'
  },
  modalClassName: {
    base: 'headerModal__content',
    afterOpen: 'headerModal__content--after-open',
    beforeClose: 'headerModal__content--before-close'
  }
})`
  .headerModal__overlay {
    position: fixed;
    z-index: 99;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: auto;
  }

  .headerModal__content {
    position: relative;
    width: 100%;
    height: 100%;
    overflow-y: auto;
    display: flex;
    flex-wrap: wrap;
    align-items: flex-end;

    [data-whatinput='mouse'] &,
    [data-whatinput='touch'] & {
      outline: 0;
    }
  }

  .headerModal__background {
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    transform: scaleX(0);
    transform-origin: center right;
    transition: transform 0.5s cubic-bezier(0.48, 0, 0.5, 1);
    will-change: transform;

    &:before,
    &:after {
      content: '';
      position: absolute;
      width: 100%;
      height: 100%;
    }

    &:after {
      background: #000000;
    }
  }

  .headerModal__content-wrapper {
    position: relative;
    width: 100%;
    min-height: 100%;
    opacity: 0;
  }

  .headerModal__header {
    opacity: 0;
  }

  .headerModal__content--after-open {
    .headerModal__background {
      transform: scaleX(1);
    }

    .headerModal__header,
    .headerModal__content-wrapper {
      transition: opacity 0.4s ease-in 0.5s;
      opacity: 1;
      display: flex;
      align-items: center;
      padding: ${px2rem('25px')};

      ${mq('s')} {
        padding: ${px2rem('35px')};
      }
      ${mq('m')} {
        padding: ${px2rem('40px')} ${px2rem('45px')};
      }
      ${mq('xl')} {
        padding: ${px2rem('40px')} ${px2rem('55px')};
      }
    }
  }

  .headerModal__content--before-close {
    .headerModal__background {
      transform: scaleX(0);
    }

    .headerModal__header,
    .headerModal__content-wrapper {
      transition: opacity 0.4s ease-in;
      opacity: 0;
    }
  }
`;

export default StyledHeaderModal;
